import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "maxInlineSize"];
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Heading, LayoutBox, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { ErrorAlertMessage } from './ErrorAlertMessage';
import { ILLUSTRATION_SIZE } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorPanel = ({
  children,
  errorId,
  illustration,
  onSubmit,
  title
}) => {
  return /*#__PURE__*/_jsx(LayoutBox, {
    paddingBlock: "space-xl",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: illustration,
      illustrationProps: {
        height: ILLUSTRATION_SIZE,
        width: ILLUSTRATION_SIZE
      },
      title: /*#__PURE__*/_jsx(Heading, {
        as: "h5",
        children: title
      }),
      children: /*#__PURE__*/_jsx(ErrorAlertMessage, {
        errorId: errorId,
        onSubmit: onSubmit,
        children: children
      })
    })
  });
};
ErrorPanel.Body = _ref => {
  let {
      children,
      maxInlineSize = '40ch'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({}, rest, {
    display: "inline-block",
    gap: "space-md",
    maxInlineSize: maxInlineSize,
    children: children
  }));
};